import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { Container, Title, Content } from './styles';

const PopUp = ({
  visible,
  setVisible,
  body,
  title,
  icon,
  large,
  medium,
  centered = false,
}) => {
  return (
    <>
      <Container
        visible={visible}
        large={large}
        medium={medium}
        centered={centered}
      >
        <Title>
          <nav>
            {icon}
            <strong>{title}</strong>
          </nav>

          <FaTimes
            size={18}
            color="#ee4256"
            onClick={() => {
              setVisible(false);
            }}
          />
        </Title>
        <Content>{body}</Content>
      </Container>
    </>
  );
};

export default PopUp;
